import { upperFirst } from 'lodash';
import { getProductFieldsFromPinnedItem } from '@/forwarding/types/pinnedItem';
import { BASE_PRODUCT_TYPE_ORDER, isDiamond, ProductType } from '@/product/constants/productTypes';
export function getPluralProductTypeText(productType) {
    if (isDiamond(productType)) {
        return 'Diamonds';
    }
    if (productType === ProductType.Gem) {
        return 'Gems';
    }
    return upperFirst(productType);
}
export function getProductTypeAndIdsPairs(items) {
    const productMap = items.reduce((acc, item) => {
        const productFields = getProductFieldsFromPinnedItem(item);
        if (!productFields) {
            return acc;
        }
        const { productType, productId } = productFields;
        const ids = acc.get(productType) ?? [];
        ids.push(productId);
        acc.set(productType, ids);
        return acc;
    }, new Map());
    return sortByProductType([...productMap.entries()]);
}
function sortByProductType(entries) {
    return entries.sort((a, b) => {
        const indexA = BASE_PRODUCT_TYPE_ORDER.indexOf(a[0]);
        const indexB = BASE_PRODUCT_TYPE_ORDER.indexOf(b[0]);
        return indexA - indexB;
    });
}
